import gql from "graphql-tag";
import graphqlClient from "../../../apollo";

class ConsensusProvider {
  getCountriesConsensus() {
    return graphqlClient.query({
      query: gql`
        query country {
          country {
            name
            consensusReport
            consensusReportResult
            forecastTool
            dataVisualizationFilter
            forecastFilter
            consensusReportFilter
          }
        }
      `,
    });
  }

  gerData(country) {
    return graphqlClient.query({
      query: gql`
        query consensus($country: String!) {
          consensus(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  gerDataResult(country) {
    return graphqlClient.query({
      query: gql`
        query consensusResults($country: String!) {
          consensusResults(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  ApplyExportExcelConsensus(headers, data, headers2, data2) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation exportExcelConsensus(
          $headers: [String]!
          $data: String!
          $headers2: [String]!
          $data2: String!
        ) {
          exportExcelConsensus(
            headers: $headers
            headers2: $headers2
            data: $data
            data2: $data2
          ) {
            url
          }
        }
      `,
      variables: {
        headers,
        data,
        headers2,
        data2,
      },
    });
  }

  gerDataFeForecast(country) {
    return graphqlClient.query({
      query: gql`
        query teForecast($country: String!) {
          teForecast(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getDataLastSemester(country) {
    return graphqlClient.query({
      query: gql`
        query lastSemester($country: String!) {
          lastSemester(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getDataBacktesting(country) {
    return graphqlClient.query({
      query: gql`
        query backtesting($country: String!) {
          backtesting(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getDataBacktestingDeviation(country, variable) {
    return graphqlClient.query({
      query: gql`
        query backtestinDeviation($country: String!, $variable: String!) {
          backtestinDeviation(country: $country, variable: $variable) {
            result
          }
        }
      `,
      variables: {
        country,
        variable,
      },
    });
  }

  getDataBacktestingDeviationMl(country, variable) {
    return graphqlClient.query({
      query: gql`
        query backtestinDeviation($country: String!, $variable: String!) {
          backtestinDeviationMl(country: $country, variable: $variable) {
            result
          }
        }
      `,
      variables: {
        country,
        variable,
      },
    });
  }
}

export default new ConsensusProvider();
